import { VotingPowerTooltip } from './VotingPowerTooltip';

/**
 * Voting Power Indicator Component
 * Displays user's voting power in the header with tooltip breakdown
 */
export function VotingPowerIndicator({ votingPower, loading, roleLabel }) {
  if (loading) {
    return (
      <div className="t24-voting-power-indicator">
        <span className="t24-voting-power-icon">⚡</span>
        <span className="t24-voting-power-text">Loading...</span>
      </div>
    );
  }

  if (!votingPower) {
    return null;
  }

  const power = votingPower.total_weight || 0;

  return (
    <VotingPowerTooltip votingPower={votingPower}>
      <div className="t24-voting-power-indicator">
        <span className="t24-voting-power-icon">⚡</span>
        <div className="t24-voting-power-text">
          <span>{window.t24Governance.strings.votingPower}:</span>
          <span className="t24-voting-power-value">{power.toFixed(1)}</span>
          {roleLabel && <span className="t24-voting-power-role">({roleLabel})</span>}
        </div>
      </div>
    </VotingPowerTooltip>
  );
}
